var exports = {
  "zr": "x93eb46d8--912b98--root",
  "DD": "x93eb46d8--912b98--title",
  "p_": "x93eb46d8--912b98--list",
};

module.exports = exports;
